import React from "react";
import CategoryTab from "./CategoryTab";
import { useLocation } from "react-router-dom";

export default function Header() {
  const location = useLocation();
  return (
    <>
      {location.pathname === "/404" ? null : (
        <section className="main-header">
          <h1 className="main-title">이든파이낸셜 정책</h1>
          <CategoryTab location={location.pathname} />
        </section>
      )}
    </>
  );
}
